/**
 * Created by jv on 04/01/2017.
 */
const config = require("Sources/config/config");

let utils = {};
let queryParams;

(function (Utils) {
  const MAX_UID = 1000000;

  Utils.UUID = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };

  Utils.generateUIDShort = function () {
    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
  };

  Utils.generateElementId = function (prefix) {
    do {
      prefix += ~~(Math.random() * MAX_UID) // "~~" acts like a faster Math.floor() here
    } while (document.getElementById(prefix));

    return prefix;
  };

  Utils.redirect = function (link) {
    window.location.href = link;
  };

  Utils.reloadPage = function (forceReload) {
    window.location.reload(forceReload);
  };

  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
  Utils.isUndefined = function (obj) {
    return typeof obj === "undefined";
  };

  Utils.isDefined = function (obj) {
    return !Utils.isUndefined(obj);
  };

  Utils.isNull = function (obj) {
    return typeof obj === "undefined" || obj === null;
  };

  Utils.isNotNull = function (obj) {
    return !Utils.isNull(obj);
  };

  Utils.isNullOrEmpty = function (str) {
    return Utils.isNull(str) || str === "";
  };

  Utils.isString = function (value) {
    return Utils.isNotNull(value) && typeof value === "string";
  };

  Utils.isBoolean = function (value) {
    return value === true || value === false;
  };

  Utils.isNumber = function (value) {
    return Utils.isNotNull(value) && !isNaN(value) && typeof value === "number";
  };

  Utils.isArray = function (obj) {
    return Utils.isNotNull(obj) && Array.isArray(obj);
  };

  Utils.isObject = function (obj) {
    return Utils.isNotNull(obj) && typeof obj === "object";
  };

  Utils.isMomentObject = function (obj) {
    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
  };

  Utils.isFunction = function (obj) {
    return typeof obj === "function";
  };

  Utils.isValidEmail = function (email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  Utils.defaultFor = function (value, defaultValue, type) {
    if (Utils.isNotNull(type) && typeof value !== type) {
      return defaultValue;
    }

    return Utils.isNotNull(value) ? value : defaultValue;
  };

  Utils.stringToInt = function (value) {
    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
      return Number(value);
    }

    return NaN;
  };

  Utils.stringToBoolean = function (value) {
    return (Utils.isNotNull(value) && (value === "true" || value === true)) ? true : false;
  };

  Utils.parseFloat = function (value) {
    let parsedValue = parseFloat(value);

    if (Utils.isNumber(parsedValue)) {
      return parsedValue;
    }

    return null;
  };

  Utils.stringifyJSON = function (obj, replacer, space) {
    return JSON.stringify(obj, replacer, space);
  };

  Utils.parseJSON = function (str, safe, nullOnError) {
    if (safe) {
      try {
        let objValue = JSON.parse(str);
        return objValue;
      } catch (e) {
        return nullOnError ? null : str;
      }
    } else {
      return JSON.parse(str);
    }
  };

  Utils.rgbToHex = function (r, g, b) {
    if (r > 255 || g > 255 || b > 255) {
      throw "Invalid color component";
    }

    let hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + ("000000" + hex).slice(-6);
  };

  Utils.hexToRgb = function (hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };

  Utils.hexToCmyk = function (hex) {
    let computedC;
    let computedM;
    let computedY;
    let computedK;

    hex = hex.replace("#", "");

    if (hex.length !== 6) {
      return null;
    }
    if (/[0-9a-f]{6}/i.test(hex) !== true) {
      return null;
    }

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // BLACK
    if (r === 0 && g === 0 && b === 0) {
      return {
        c: 0,
        m: 0,
        y: 0,
        k: 1
      };
    }

    computedC = 1 - (r / 255);
    computedM = 1 - (g / 255);
    computedY = 1 - (b / 255);

    let minCMY = Math.min(computedC, Math.min(computedM, computedY));

    computedC = (computedC - minCMY) / (1 - minCMY);
    computedM = (computedM - minCMY) / (1 - minCMY);
    computedY = (computedY - minCMY) / (1 - minCMY);
    computedK = minCMY;

    return {
      c: computedC,
      m: computedM,
      y: computedY,
      k: computedK
    };
  };

  Utils.roundNumber = function (number, decimals) {
    if (Utils.isNumber(number)) {
      let rounder = Math.pow(10, decimals);
      return Math.round(number * rounder) / rounder;
    }

    return NaN;
  };

  Utils.format = function (format) {
    let args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
      return utils.isDefined(args[number]) ? args[number] : match;
    });
  };

  Utils.formatMoney = function (value, currency) {
    if (currency.beforePrice) {
      return currency.escapedSymbol + "" + utils.formatNumber(utils.roundNumber(value, 2), {decimalLength: 2});
    }

    return utils.formatNumber(utils.roundNumber(value, 2), {decimalLength: 2}) + "" + currency.symbol;
  };

  Utils.formatNumber = function (value, options) {
    if (!utils.isNumber(value)) return null;

    options = utils.isNotNull(options) ? options : {};

    let decimalLength = ~~options.decimalLength,
      groupLength = utils.isNumber(options.groupLength) ? options.groupLength : 3,
      groupDelimiter = options.groupDelimiter || ",",
      decimalDelimiter = options.decimalDelimiter;

    let re = "\\d(?=(\\d{" + groupLength + "})+" + (decimalLength > 0 ? "\\D" : "$") + ")",
      num = value.toFixed(Math.max(0, decimalLength));

    return (decimalDelimiter ? num.replace(".", decimalDelimiter) : num).replace(new RegExp(re, "g"), "$&" + groupDelimiter);
  };

  Utils.getRandomIntInclusive = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  Utils.getContrastYIQ = function (hexColor) {
    hexColor = hexColor.replace("#", "");

    let r = parseInt(hexColor.substr(0, 2), 16);
    let g = parseInt(hexColor.substr(2, 2), 16);
    let b = parseInt(hexColor.substr(4, 2), 16);
    let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return yiq;
  };

  Utils.getContrastColor = function (color, options) {
    options = Utils.isNotNull(options) ? options : {};

    let yiqColor = Utils.getContrastYIQ(color);

    let threshold = Utils.isNumber(options.threshold) ? options.threshold : 256 / 2;
    let belowThresholdColor = Utils.isNotNull(options.belowThresholdColor) ? options.belowThresholdColor : "#ffffff";
    let aboveThresholdColor = Utils.isNotNull(options.aboveThresholdColor) ? options.aboveThresholdColor : "#000000";

    return yiqColor < threshold ? belowThresholdColor : aboveThresholdColor;
  };

  Utils.invertColor = function (hexColor) {
    hexColor = hexColor.replace("#", "");       // remove #
    hexColor = parseInt(hexColor, 16);          // convert to integer
    hexColor = 0xFFFFFF ^ hexColor;             // invert three bytes
    hexColor = hexColor.toString(16);           // convert to hex
    hexColor = ("000000" + hexColor).slice(-6); // pad with leading zeros
    hexColor = "#" + hexColor;                  // prepend #

    return hexColor;
  };

  Utils.arraysAreEqual = function (arr1, arr2) {
    if (arr1 === arr2) return true;
    if (utils.isNull(arr1) || utils.isNull(arr2)) return false;
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  };

  Utils.resetFormElement = function (el) {
    $(el).wrap("<form></form>").closest("form").get(0).reset();
    $(el).unwrap();
  };

  Utils.setButtonLoading = function ($element, flag) {
    if (utils.isNull($element) || !$element.length) return;

    $element.prop("disabled", flag);

    if (flag) {
      $element.addClass("btn-loading");
    } else {
      $element.removeClass("btn-loading");
    }
  };

  Utils.getServiceUrl = function (path) {
    return config.serviceBaseURL + path;
  };

  Utils.luhnCheck = function (str) {
    return str.split("").reduceRight(function (prev, curr, idx) {
      if ((idx + 1) % 2 !== 0) {
        curr = (curr * 2).toString().split("").reduce(function (p, c) {
          return (+p) + (+c);
        });
      }
      return (+prev) + (+curr);
    }) % 10 === 0;
  };

  Utils.resolveProperty = function (path, obj) {
    return path.split(".").reduce(function (prev, curr) {
      return prev ? prev[curr] : null;
    }, obj || self);
  };

  Utils.setPropertyValue = function (path, obj, value, createMissing) {
    return path.split(".").reduce(function (prev, curr, index, arr) {
      if (createMissing && utils.isNotNull(prev) && !prev.hasOwnProperty(curr)) {
        if (index < arr.length - 1) {
          prev[curr] = {};
        }
      }

      // Note: maybe add check to see if prev is an object and also check to see

      if (index === arr.length - 1) {
        prev[curr] = value;
      }

      return prev ? prev[curr] : null;
    }, obj || self);
  };

  Utils.getQueryParam = function (name) {
    return queryParams[name];
  };

  Utils.getUrlPath = function () {
    return window.location.pathname;
  };

  Utils.getPathSection = function (index) {
    let path = window.location.pathname;
    let pathSections = path.split("/");

    for (let i = 0; i < pathSections.length; i++) {
      let pathSection = pathSections[i];

      if (Utils.isNullOrEmpty(pathSection)) {
        index++;
        continue;
      }

      if ((i + 1) === index) {
        return pathSection;
      }
    }

    return null;
  };

  Utils.getPathSectionLength = function () {
    let path = window.location.pathname;
    let pathSections = path.split("/");

    return pathSections.length;
  };

  Utils.btoa = function (stringToEncode) {
    return Utils.isNotNull(stringToEncode) ? window.btoa(encodeURIComponent(stringToEncode)) : null;
  };

  Utils.atob = function (stringToDecode) {
    return Utils.isNotNull(stringToDecode) ? decodeURIComponent(window.atob(stringToDecode)) : null;
  };

  let entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;", // eslint-disable-line
    "'": "&#39;",
    "/": "&#x2F;"
  };

  Utils.escapeHtml = function (string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  };

  Utils.debounce = function (func, wait, immediate, context) {
    let timeout;
    return function () {
      context = context || this;
      let args = arguments;
      let later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
}(utils));

// Load query parameters once
(window.onpopstate = function () {
  let match,
    pl = /\+/g,  // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = window.location.search.substring(1);

  queryParams = {};
  while (match = search.exec(query)) {
    let name = decode(match[1]);
    let value = decode(match[2]);

    if (queryParams.hasOwnProperty(name)) {
      if (!utils.isArray(queryParams[name])) {
        // Make it an array
        queryParams[name] = [queryParams[name]];
      }

      queryParams[name].push(value);
    } else {
      queryParams[name] = value;
    }
  }
})();

module.exports = utils;



// WEBPACK FOOTER //
// ./app/js/utils/utils.js